/**
 * OVERRIDE NewsItemView.jsx
 */

import NewsItemView from '../../../../components/News/NewsItemView';

export default NewsItemView;